import { ceres_api } from "@/axios-config.js"

const IrrigationUpkeeps = {
    getIrrigationUpkeeps(farm_id, filter) {
        let endpoint = "/farms/" + farm_id + "/irrigation_upkeeps"
        if (filter == undefined) {
            return ceres_api.get(endpoint)
        } else {
            return ceres_api.post(endpoint + "/filter", { filter: filter })
        }
    },
    createIrrigationUpkeep(farm_id, model) {
        let endpoint = "/farms/" + farm_id + "/irrigation_upkeeps"
        return ceres_api.post(endpoint, model)
    },
    getIrrigationUpkeep(farm_id, id) {
        let endpoint = "/farms/" + farm_id + "/irrigation_upkeeps/"
        return ceres_api.get(endpoint + id)
    },
    deleteIrrigationUpkeep(farm_id, id) {
        let endpoint = "/farms/" + farm_id + "/irrigation_upkeeps/"
        return ceres_api.delete(endpoint + id)
    },
    updateIrrigationUpkeep(farm_id, id, model) {
        let endpoint = "/farms/" + farm_id + "/irrigation_upkeeps/"
        return ceres_api.put(endpoint + id, model)
    }
}

export default IrrigationUpkeeps
